const Colors = {
    lightGreen: '#AAFA8B',
    lightGreen2: '#A5D8AA',
    green: '#3EA448',
    lightBlue: 'rgba(86, 204, 242, 0.6)',
    lightBlue2: '#D1EAFF',
    blue: '#2D9CDB',
    blue2: '#4A90E2',
    red: '#EB5757',
    lightGray: '#F8F8F8',
    lightGray2: ' #CCCCCC',
    mediumGray: '#828282',
    mediumGray2: '#6C6767',
    darkGray: '#292929',
    darkGray2: '#4F4F4F',
    gray: '#B0B0B0',
    yellow: '#F2C94C',
    white: '#FFFFFF',
    black: '#000000',
    orange: '#EF8758',
    purple: '#9932CC',
};

export default Colors;